module.exports = __webpack_public_path__ + "static/30-ans.621bb8d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30-ans.png
// module id = 498
// module chunks = 136956383308509